var flkty1;

function initFlickity1() {
  flkty1 = new Flickity('#pc-main-carousel', {
    cellAlign: 'left',
    contain: true,
    pageDots: true,
    freeScroll: true,
    groupCells: 1, // Adjust the number of cells based on screen size
  });
}

function getGroupCells() {
  if (window.innerWidth < 768) {
    return 1; // Display one box at a time on small screens
  } else {
    return 4; // Display two boxes at a time on extra-large screens
  }
}

// Initialize Flickity for the first slider on page load
initFlickity1();

// Update Flickity groupCells for the first slider on window resize
window.addEventListener('resize', function() {
  flkty1.destroy(); // Destroy the current Flickity instance
  initFlickity1(); // Reinitialize Flickity with updated options
});



